import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CredentialsOneComponent } from '../../../components/credentials-design/credentials-one/credentials-one.component';
import { CredentialsTwoComponent } from '../../../components/credentials-design/credentials-two/credentials-two.component';
import { CredentialHeaderComponent } from '../../layout/credential/credential-header/header.component';
import { CredentialFooterComponent } from '../../layout/credential/credential-footer/credential-footer.component';

@Component({
  selector: 'app-campaign-page',
  standalone: true,
  imports: [
    CredentialsOneComponent,
    CredentialsTwoComponent,
    CredentialHeaderComponent,
    CredentialFooterComponent
  ],
  templateUrl: './campaign-page.component.html',
  styleUrl: './campaign-page.component.scss'
})
export class CampaignPageComponent {

  slug = "";
  @Input() isComponent = false;
  @Input() headerBackground = "";
  @Input() headerTextColor = "";
  @Input() footerBackground = "";
  @Input() footerTextColor = "";
  @Input() mainBackground = "";
  @Input() textCampaign = "";
  @Input() imageCampaign = "";
  @Input() selectTextOrImage: 1 | 2 = 1;
  @Input() formDesing: 'desing-01' | 'desing-02' | null = null;
  @Input() logoCampaign: string | null = null;
  // Inputs del formulario de credencial
  @Input() credentialTitle = 'Genera tu credencial';
  @Input() credentialFormBackground = '#000000';
  @Input() credentialDesign = '1';
  @Input() credentialButtonUpload = '#000000';
  @Input() credentialButtonGenerate = '#000000';
  @Input() credentialButtonUploadStyle = 'uppercase';
  @Input() credentialButtonGenerateStyle = 'uppercase';
  @Input() credentialImage = 'assets/img/avatar.png';

  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.slug = params['slug'] || '';
      console.log(`Campaign slug: ${this.slug}`);
    });

    console.log('CampaignPageComponent initialized');
  }

}
